// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__XsliO","logo":"style__logo__51jx3"};